'use strict';

module.exports = {
  getWatchFn: function (key, ctrl) {
    return function () {
      return ctrl[key];
    };
  },

  /**
   * Convenience function to watch a property on the controller. The handler only
   * fires after the initial load.
   * 
   * @param  {[type]} $scope  [description]
   * @param  {[type]} ctrl    [description]
   * @param  {[type]} prop    [description]
   * @param  {[type]} handler [description]
   * @return {[type]}         [description]
   */
  watch: function ($scope, ctrl, prop, handler, type) {
    var watcher = $scope.$watch.bind($scope);

    if (type === 'collection') {
      watcher = $scope.$watchCollection.bind($scope);
    }

    watcher(this.getWatchFn(prop, ctrl), function (newVal, oldVal) {
      if (newVal !== oldVal) {
        handler(newVal, oldVal);
      }
    });
  }
};


// WEBPACK FOOTER //
// ./src/common/utils/CtrlUtil.js